"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const thread_1 = require("../../../app/dist/thread");
exports.toolDef = {
    name: 'loom_set_thread_deps',
    description: "Set a thread's hard `depends_on` edges on its `thread.md` (the roadmap dependency graph). Targets are other threads' `th_` ULIDs. The write is REFUSED if it would introduce a cycle, target an unknown thread, or make the thread depend on itself — validation at write time so the read-model rarely renders a broken graph. Identifies the thread by its `th_` ULID. Use this tool — do not edit weave files directly.",
    inputSchema: {
        type: 'object',
        properties: {
            thread_ulid: { type: 'string', description: "The thread's th_ ULID (its thread.md id)" },
            depends_on: { type: 'array', items: { type: 'string' }, description: 'th_ ULIDs this thread depends on (replaces the existing list)' },
        },
        required: ['thread_ulid', 'depends_on'],
    },
};
async function handle(root, args) {
    const result = await (0, thread_1.setThreadDeps)({ threadUlid: args['thread_ulid'], dependsOn: args['depends_on'] ?? [] }, { getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root), saveDoc: dist_1.saveDoc, loadDoc: dist_1.loadDoc, fs });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
